import "./css/output.css";
import Home from "./pages/Home";

const App = () => {
    return <Home />;
};

export default App;
